import React from 'react';
import { SeoHead } from './components/SeoHead';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MobileStickyBar } from './components/MobileStickyBar';
import { Hero } from './components/sections/Hero';
import { OutcomesRibbon } from './components/sections/OutcomesRibbon';
import { TrustStrip } from './components/sections/TrustStrip';
import { AnswerFirst } from './components/sections/AnswerFirst';
import { BuyerPain } from './components/sections/BuyerPain';
import { Services } from './components/sections/Services';
import { Industries } from './components/sections/Industries';
import { Infrastructure } from './components/sections/Infrastructure';
import { Process } from './components/sections/Process';
import { MidCTA } from './components/sections/MidCTA';
import { ITReview } from './components/sections/ITReview';
import { CaseStudies } from './components/sections/CaseStudies';
import { Testimonials } from './components/sections/Testimonials';
import { Resources } from './components/sections/Resources';
import { Leadership } from './components/sections/Leadership';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
export function App() {
  return <div className="min-h-screen w-full bg-white font-body text-ink" data-id="element-0">
      <SeoHead data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <OutcomesRibbon data-id="element-5" />
        <TrustStrip data-id="element-6" />
        <AnswerFirst data-id="element-7" />
        <BuyerPain data-id="element-8" />
        <Services data-id="element-9" />
        <Industries data-id="element-10" />
        <Infrastructure data-id="element-11" />
        <Process data-id="element-12" />
        <MidCTA data-id="element-13" />
        <ITReview data-id="element-14" />
        <CaseStudies data-id="element-15" />
        <Testimonials data-id="element-16" />
        <Resources data-id="element-17" />
        <Leadership data-id="element-18" />
        <FAQ data-id="element-19" />
        <FinalCTA data-id="element-20" />
      </main>
      <Footer data-id="element-21" />
      <MobileStickyBar data-id="element-22" />
    </div>;
}